<script lang="ts">
    import External from '$lib/icons/external.svg';

    export let title: string | undefined = '';
    export let links: {
        link: string;
        label: string;
        enabled: boolean;
        external: boolean;
        action: (() => void) | undefined;
    }[] = [];
</script>

<div class="flex flex-col gap-2xs">
    <div class="text-sm font-bold text-grey-70 tablet:text-base tablet:font-bold">{title}</div>
    {#each links as link}
        {#if link.enabled}
            <div class="flex items-center gap-3xs">
                {#if link.action}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-no-static-element-interactions -->
                    <div
                        class="cursor-pointer text-sm text-grey-70 tablet:text-base"
                        on:click={link.action}
                    >
                        <div>{link.label}</div>
                    </div>
                {:else}
                    <a
                        href={link.link}
                        target={link.external ? '_blank' : ''}
                        class="text-sm text-grey-70 tablet:text-base">{link.label}</a
                    >
                {/if}
                {#if link.external}
                    <External class="h-xs w-xs text-grey-20" />
                {/if}
            </div>
        {/if}
    {/each}
</div>
